<template>
	<section class="restaurants">
		<div class="container">
			<el-breadcrumb separator="<">
				<el-breadcrumb-item :to="{ path: '/' }"
					>главная</el-breadcrumb-item
				>
				<el-breadcrumb-item>Наши рестораны</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="restaurants__inner d-flex flex-wrap items-start">
				<h2 class="page-title">Наши рестораны</h2>

				<div class="restaurants-list d-flex flex-wrap">
					<restaurant-item
						v-for="organization in organizations"
						:key="organization.id"
						:organization="organization"
					/>
				</div>

				<promotional-slider />
			</div>
		</div>
	</section>
</template>

<script>
import RestaurantItem from '../elements/RestaurantItem';
import PromotionalSlider from '../elements/PromotionalSlider';
import { api } from '@/api';
import SeoMixin from '@/mixins/seo-meta.js';

export default {
	name: 'OurRestaurants',
	mixins: [
		SeoMixin,
	],
	props: {
		seo: {
			type: Array
		}
	},
	components: {
		RestaurantItem,
		PromotionalSlider,
	},
	head() {
		return this.metaSeo();
	},
	data() {
		return {
			organizations: [],
		};
	},
	/*beforeMount() {
		this.loadSeo(this.$root.seo);
	},*/
	async mounted() {
		this.organizations = await this.loadAllOrganization();
	},
	methods: {
		async loadAllOrganization() {
			return await api.getAllOrganization().then((response) => {
				console.log(response.data);
				return response.data;
			});
		},
	},
};
</script>
